



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApiResponse } from '@/components/types';
import CourtSelect from "@/modules/court/components/CourtSelect.vue";
import { UPDATE_ACCOUNT } from "@/modules/accounting/store";
import { Account, UpdateAccount } from "@/modules/accounting/types";

const AccountingStore = namespace('accounting');

@Component({
  components: { CourtSelect }
})
export default class UpdateAccountDialog extends Vue {
  @Prop() value!: Account | null;

  @AccountingStore.Action(UPDATE_ACCOUNT) updateAccount!: (command: UpdateAccount) => Promise<ApiResponse>;

  error: any = null;
  dialog: boolean = false;

  command: UpdateAccount = {
    account_id: '',
    court_id: '',
    code: ''
  };

  @Watch('dialog')
  watchDialogClosed(value: boolean) {
    if (value !== false) return;

    setTimeout(() => {
      this.clear();
    }, 200);
  }

  @Watch('value')
  watchValue(value: Account) {
    if (!value) return;

    this.init();

    setTimeout(() => {
      this.dialog = true;
    }, 200);
  }

  clear() {
    this.command = {
      account_id: '',
      court_id: '',
      code: ''
    };

    this.error = null;
    this.$emit('input', null);
    // @ts-ignore
    this.$refs.form.reset();
  }

  init() {
    if (!this.value) return;

    this.command = {
      account_id: this.value.id,
      court_id: this.value.court.id,
      code: this.value.code
    };
  }

  async save(): Promise<ApiResponse> {
    this.error = null;

    return this.updateAccount(this.command);
  }
}
